// extracted by mini-css-extract-plugin
module.exports = {"tabTitles":"styles_tabTitles__TS7aD","tabContentTitle":"styles_tabContentTitle__3Q2jN","tabContentList":"styles_tabContentList__7cb8p"};
module.exports.__checksum = "5d5944ee64d4"
